import { render, staticRenderFns } from "./SettlementDetail.vue?vue&type=template&id=6d79a6c3&"
import script from "./SettlementDetail.vue?vue&type=script&lang=js&"
export * from "./SettlementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports